module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInRight"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Сбрасываем пароль..."
    }
  }) : (_vm.error) ? _c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Ошибка сброса пароля")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.error) + "\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'RemindPassword'
      }
    }
  }, [_vm._v("Вернуться к странице сброса пароля")])], 1)])]) : _c('form', {
    staticClass: "col-lg-6 col-md-8 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.resetPassword()
      }
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Задать новый пароль")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-2 mb-2"
  }, [_vm._v("\n                        Укажите уникальный новый пароль\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newPassword.$error
    }
  }, [_c('label', {
    staticClass: "col-12 col-md-6 col-form-label",
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("Новый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "new-password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }, function($event) {
        _vm.$v.newPassword.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newPassword.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Новый пароль должен быть не менее 6 символов")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.remindNewPassword.$error
    }
  }, [_c('label', {
    staticClass: "col-12 col-md-6  col-form-label",
    attrs: {
      "for": "remind-new-password"
    }
  }, [_vm._v("Повторите новый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remindNewPassword),
      expression: "remindNewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "remind-new-password"
    },
    domProps: {
      "value": (_vm.remindNewPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.remindNewPassword = $event.target.value
      }, function($event) {
        _vm.$v.remindNewPassword.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.remindNewPassword.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пароли должны совпадать")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12 offset-md-6 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': _vm.$v.remindNewPassword.$invalid
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.remindNewPassword.$invalid
    }
  }, [_vm._v("Сменить пароль")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-862ab784"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/ResetPasswordEmail.vue
// module id = 1056
// module chunks = 1